export default function (value, useRaw = false) {
  if (Number.isNaN(value)) {
    return useRaw ? value : '';
  }

  if (!Number.isFinite(value)) {
    return useRaw ? value : '';
  }

  if (value > 0) {
    return Math.floor(value).toLocaleString();
  }

  if (value < 0) {
    const rounded = Math.ceil(value);

    if (rounded === 0) {
      return 0;
    }

    return rounded.toLocaleString();
  }

  return 0;
};
